import React, { useEffect, useState } from 'react';
import { Button, Input } from '..';
import {
  FiHash,
  FiFileText,
  FiEdit,
} from 'react-icons/fi';
import { toast } from 'react-toastify';
import Api from '../../Api';
import '../CompanyForm/style.css';

import { Select } from '..';

export default function CostCenterForm({ companyId, initialData, onSuccess, onCancel, companies = [] }) {
  const isEdit = !!initialData;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    code: '',
    name: '',
    description: '',
    company_id: companyId || '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData(prev => ({
        ...prev,
        ...initialData,
        company_id: initialData.company_id || companyId || '',
      }));
    }
  }, [initialData, companyId]);

  function handleChange(event) {
    const { id, value } = event.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  }

  function validateForm() {
    const messages = [];

    if (!formData.name || !formData.name.trim()) {
      messages.push('Informe o nome do centro de custo.');
    }

    if (!formData.company_id) {
      messages.push('Selecione uma empresa.');
    }

    if (messages.length > 0) {
      messages.forEach(message => toast.error(message));
      return false;
    }

    return true;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');

    const isValid = validateForm();
    if (!isValid) return;

    setLoading(true);

    try {
      if (isEdit) {
        await Api.updateCostCenter(initialData.company_id, initialData.id, formData);
        toast.success('Centro de custo atualizado com sucesso!');
      } else {
        await Api.createCostCenter(formData.company_id, formData);
        toast.success('Centro de custo criado com sucesso!');
      }
      onSuccess();
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        err.message ||
        'Ocorreu um erro ao salvar. Tente novamente.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form className="company-form-component" onSubmit={handleSubmit}>
      <div className="form-body">
        {error && <div className="form-error-banner">{error}</div>}

        <div className="form-grid" style={{ gridTemplateColumns: '1fr', marginTop: '0px' }}>
          <Select
             id="company_id"
             label="Empresa *"
             value={formData.company_id}
             onChange={handleChange}
             options={companies.map(c => ({ value: c.id, label: c.trade_name || c.corporate_name }))}
             placeholder="SELECIONE UMA EMPRESA..."
             searchable
          />
        </div>

        <div className="form-grid" style={{ gridTemplateColumns: '1fr 2fr', marginTop: '10px' }}>
          <Input
            id="code"
            label="Código"
            value={formData.code}
            onChange={handleChange}
            placeholder="Ex: 001"
            icon={FiHash}
          />
          <Input
            id="name"
            label="Nome"
            value={formData.name}
            onChange={handleChange}
            placeholder="Ex: Administrativo"
            icon={FiFileText}
          />
        </div>

        <div className="form-grid" style={{ gridTemplateColumns: '1fr', marginTop: '10px' }}>
          <Input
            id="description"
            label="Descrição"
            value={formData.description}
            onChange={handleChange}
            placeholder="Informações adicionais..."
            icon={FiEdit}
            multiline
            rows={4}
          />
        </div>
      </div>

      <div className="form-actions">
        <Button
          type="button"
          className="cancel-button"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          disabled={loading}
        >
          {loading ? 'Salvando...' : 'Salvar'}
        </Button>
      </div>
    </form>
  );
}
